import novin from './novin'
import saman from './saman'
import parsian from './parsian'
import pasargad from './pasargad'

export {
    novin,
    saman,
    parsian,
    pasargad,
}